import { ScreenType } from '../../interfaces/platform/Platform'

export default function getScreenType (): ScreenType {
  // return window.innerWidth > window.innerHeight ? 'web' : 'mobile'
  return window.innerWidth > 540 ? 'web' : 'mobile'
}
